/**
 * Hvilken logo som gjelder.
 *
 * Brukeren 29.10.2026: «Hvis det blir lastet opp en logo på et selskap, så
 * byttes logoen vi har i appen og på nettsiden til logoen til selskapet,
 * hvis det lastes opp logo til prosjektet er det prosjektslogoen som vises
 * i appen og på nettflaten.»
 *
 * Regelen er én linje, og den ligger her fordi den skal leses tre steder:
 * menyen på nettflata, toppstripa i feltappen og øverst i rapport-PDF-en.
 * Skrevet tre ganger ville den blitt tre regler i det øyeblikket en av dem
 * fikk en rettelse.
 *
 * Tom streng teller som ingen logo. Den kommer av et felt som er ryddet,
 * ikke av et valg, og en sti på null tegn peker ikke på noe.
 */
export function velgLogo(
  produksjon: string | null | undefined,
  selskap: string | null | undefined,
): string | null {
  const p = produksjon ?? "";
  if (p !== "") return p;
  const s = selskap ?? "";
  if (s !== "") return s;
  return null;
}
